import React from "react";
import CardSimple from "../../../../components/basic/CardSimple";

const SmartInventory = () => {
  return (
    <div id="create-purchase-order">
      <br />
      <div>
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Create a Purchase Order</h2>
            <h3 style={{ color: "#000" }}>Purchase Order</h3>
            <p>
                Purchase
              Under Inventory, you can create, receive and track orders.
            </p>
            <p>
              You can track the status of the placed order. An{" "}
              <strong>Opened Order</strong> means that the order was placed and the store is 
              waiting for its arrival. An <strong>In Progress Order</strong>{" "}
              means that part of the order was received but the order has not been completed
              yet. A <strong>Closed Order</strong> means that the order was
              fully received. A status of <strong>Cancel</strong> means that the order
              was cancelled. When an order has a status of{" "}
              <strong>Closed</strong> or Cancel, no further changes can be
              made to it.
            </p>
            <ul>
              <li>Go to Inventory > Purchase Order</li>
              <img
                src={require("./SupportDocImages/product_images/product.PNG")}
              />
              <li>
                Click the Add button, located on the right side of the screen.
              </li>
              <img src="http://techpos.ca/support-images/SmartInventory/PurchaseOrder/PO-2.png" />
              <li>
                Select a vendor, give a description, select a payment date and
                an expected date
              </li>
              <img
                src="http://techpos.ca/support-images/SmartInventory/PurchaseOrder/PO-3.png"
                width="600"
              />
              <li>
                To add an item, type the item name under Choose an Existing Product
              </li>
              <img src="http://techpos.ca/support-images/SmartInventory/PurchaseOrder/PO-4.png" />
              <li>Enter the quantity</li>
              <img src="http://techpos.ca/support-images/SmartInventory/PurchaseOrder/PO-5.png" />
              <li>On Invoice Price, type the amount to pay</li>
              <img src="http://techpos.ca/support-images/SmartInventory/PurchaseOrder/PO-6.png" />
              <li>
                If your supplier has provided you with a Package number, you can
                type it on the package number, else, the system generates a
                number for you.
              </li>
              <img src="http://techpos.ca/support-images/SmartInventory/PurchaseOrder/PO-7.png" />
              <li>Click on Save.</li>
              <li>You can add more items by clicking the button Add Item. </li>
              <img
                src="http://techpos.ca/support-images/SmartInventory/PurchaseOrder/PO-8.png"
                width="600"
              />
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="edit-purchase-order">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Edit a Purchase Order</h2>
            <p>
              <strong>
                NOTE: Only orders with a status of Opened and In progress can be
                edited
              </strong>
            </p>
            <ul>
              <li>Go to Inventory > Purchase Order</li>
              <img
                src={require("./SupportDocImages/product_images/product.PNG")}
              />
              <li>Click the Edit button of PO you want to edit.</li>
              <img src="http://techpos.ca/support-images/SmartInventory/PurchaseOrder/PO-Edit.png" />
              <li>Make the changes you need to</li>
              <li>Click on Save</li>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="receive-product">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Receive a product</h2>
            <ul>
              <li>Go to Menu > Inventory > Purchase Orders</li>
              <img
                src={require("./SupportDocImages/product_images/product.PNG")}
              />
              <li>Locate the section Product In Transit</li>
              <img
                src={require("./SupportDocImages/product_images/product2.PNG")} width="800px"
              />
              <li>Locate the Product you want to receive</li>
              <img src="http://techpos.ca/support-images/SmartInventory/PurchaseOrder/PO-11.png" />
              <li>
                Enter the Actual Quantity you received and Click on the receive
                icon
              </li>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="create-joint">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Create joints</h2>
            <ul>
              <li>Go to STORAGE Warehouse</li>
              <img
                src="http://techpos.ca/support-images/SmartInventory/Joints/joint-1.png"
                width="600"
              />
              <li>Select the flower you want to add for joint</li>
              <img src="http://techpos.ca/support-images/SmartInventory/Joints/joint-2.png" />
              <li>
                Select the Joint / Pre-Roll and enter the amount you wish to
                create
              </li>
              <img src="http://techpos.ca/support-images/SmartInventory/Joints/joint-3.png" />
              <li>Click on Create</li>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="transfer-product">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>Transfer Products between Warehouses</h2>
            <ul>
              <li>
                Click on Transfer
              </li>
              <img
                src={require("./SupportDocImages/product_images/product3.PNG")}
              />
              <li>
                Locate the Warehouse where you want the product to be
                transferred from (e.g. STORE Warehouse but, could be any
                warehouse) and fill out the form
              </li>
              <img
                src={require("./SupportDocImages/product_images/product4.PNG")} width="800px"
              />
              <li>Click on Save</li>
              <p>
                <strong>
                  NOTE: Transferring to Sell Warehouse will put the products on
                  Sale.
                </strong>
              </p>
            </ul>
          </div>
        </CardSimple>
      </div>
      <div id="adjust-item">
        <br />
        <CardSimple>
          <div className="support-wrapper support-manual">
            <h2>What is adjusting items?</h2>
            <p>
              This is a useful function when products loose weight or change
              stock levels due to extraordinary reasons
            </p>
            <ul>
            <li>
                Click on Adjust
              </li>
              <img
                src={require("./SupportDocImages/product_images/product3.PNG")}
              />
              <li>Fill out the form and then Save</li>
              <img src="http://techpos.ca/support-images/SmartInventory/AdjustProducts/AdjProd-3.png" />
              <p>
                <strong>NOTE: You can make adjustments to any warehouse</strong>
              </p>
            </ul>
          </div>
        </CardSimple>
      </div>
    </div>
  );
};

export default SmartInventory;
